import ExcelJS from "exceljs";
import { IGenerateReport } from "../interfaces/IGenerateReport";

export const GenerateXlsxReport = async ({
  lists,
  headers,
  date,
  dateRangeFrom,
  dateRangeTo,
  batchNumber,
  reportPartnerName,
  fullName,
  formattedDateTime,
  totalPHP,
  totalUSD,
  totalPrincipalPHP,
  totalPrincipalUSD,
  totalFeePHP,
  totalFeeUSD,
  username,
}: IGenerateReport) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("File Upload Report");

  // Determine date info
  let dateLabel = "N/A";
  let dateValue = "N/A";

  if (date) {
    dateLabel = "Date";
    dateValue = date;
  } else if (dateRangeFrom && dateRangeTo) {
    dateLabel = "Date Range";
    dateValue = `${dateRangeFrom} - ${dateRangeTo}`;
  } else if (batchNumber) {
    dateLabel = "Batch Number";
    dateValue = batchNumber;
  }

  // --- Meta Information ---
  const meta = [
    ["Report Name", "CORPORATE DISBURSEMENT REPORT"],
    [dateLabel, dateValue],
    ["Partner Name", reportPartnerName],
    ["Printed By", fullName],
    ["Run Date", formattedDateTime],
  ];

  meta.forEach((row) => {
    const newRow = worksheet.addRow(row);
    newRow.getCell(1).font = { bold: true };
    newRow.getCell(1).alignment = { vertical: "middle", horizontal: "left" };
  });

  worksheet.addRow([]);

  // --- Table Header ---
  const tableHeader = ["NO", ...headers.map((h: { label: string }) => h.label)];
  const headerRow = worksheet.addRow(tableHeader);

  headerRow.eachCell((cell) => {
    cell.font = { bold: true, color: { argb: "000000" } };
    cell.alignment = { vertical: "middle", horizontal: "left" };
  });

  // --- Data Rows ---
  lists.forEach((item, index) => {
    worksheet.addRow([
      index + 1,
      ...headers.map((header) => item[header.id]),
    ]);
  });

  worksheet.addRow([]);
  worksheet.addRow([]);

  // --- Footer ---
  const footerData = [
    [
      "Total Count (PHP)",
      totalPHP,
      "",
      "Total Principal (PHP)",
      totalPrincipalPHP,
      "",
      "Total Charge (PHP)",
      totalFeePHP,
    ],
    [
      "Total Count (USD)",
      totalUSD,
      "",
      "Total Principal (USD)",
      totalPrincipalUSD,
      "",
      "Total Charge (USD)",
      totalFeeUSD,
    ],
  ];

  footerData.forEach((row) => {
    const footerRow = worksheet.addRow(row);
    footerRow.eachCell((cell) => {
      cell.alignment = { vertical: "middle", horizontal: "left" };
    });
  });

  // --- Column Widths ---
  worksheet.columns.forEach((col) => {
    col.width = 20;
  });

  // --- Align all cells to left ---
  worksheet.eachRow((row) => {
    row.eachCell((cell) => {
      cell.alignment = { vertical: "middle", horizontal: "left" };
    });
  });

  // --- Download file ---
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const fileName = `${username}_${formattedDateTime}_Report.xlsx`;
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(link.href);
};
